import { render, staticRenderFns } from "./jgqk.vue?vue&type=template&id=a329a89e&scoped=true&"
import script from "./jgqk.vue?vue&type=script&lang=js&"
export * from "./jgqk.vue?vue&type=script&lang=js&"
import style0 from "./jgqk.vue?vue&type=style&index=0&id=a329a89e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a329a89e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a329a89e')) {
      api.createRecord('a329a89e', component.options)
    } else {
      api.reload('a329a89e', component.options)
    }
    module.hot.accept("./jgqk.vue?vue&type=template&id=a329a89e&scoped=true&", function () {
      api.rerender('a329a89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jgqk.vue"
export default component.exports